import axios, { AxiosInstance } from 'axios'
import { HttpStatusCodes } from 'enums'

import { getAirlockBeUrl } from 'utils/env'

import { getCurrentUser, signOut } from './auth/airlockBe'

const configApi = (api: AxiosInstance) => {
  api.interceptors.request.use(async config => {
    const tokenId: string | undefined = getCurrentUser()?.token // Add logic to retrieve User token
    if (!config.headers.Authorization) {
      config.headers.Authorization = 'Bearer ' + tokenId
    }
    return config
  })

  api.interceptors.response.use(
    response => {
      return response
    },
    error => {
      if (error.response) {
        if (
          error.response.status === HttpStatusCodes.Unauthorized ||
          (error.response.status === HttpStatusCodes.InternalServerError &&
            error.response.data.message?.toLowerCase() === 'jwt expired')
        ) {
          signOut()
        }
      }

      return Promise.reject(error)
    }
  )
}

const apiV1 = axios.create({
  withCredentials: true,
  baseURL: getAirlockBeUrl()
})

const apiV2 = axios.create({
  withCredentials: true,
  baseURL: getAirlockBeUrl('v2')
})

configApi(apiV1)
configApi(apiV2)

export default apiV1

export { apiV1, apiV2 }
